import momentjs from 'moment-jalaali';
const monthNames = {
    ltr: [
      '01 January',
      '02 February',
      '03 March',
      '04 April',
      '05 May',
      '06 June',
      '07 July',
      '08 August',
      '09 September',
      '10 October',
      '11 November',
      '12 December',
    ],
    rtl: [
      '01 فروردین',
      '02 اردیبهشت',
      '03 خرداد',
      '04 تیر',
      '05 مرداد',
      '06 شهریور',
      '07 مهر',
      '08 آبان',
      '09 آذر',
      '10 دی',
      '11 بهمن',
      '12 اسفند',
    ],
    hijri: [
      '01 محرم',
      '02 صفر',
      '03 ربیع-اول',
      '04 ربیع-ثانی',
      '05 جمالی-اول',
      '06 جمالی-ثانی',
      '07 رجب',
      '08 شعبان',
      '09 رمضان',
      '10 شوال',
      '11 ذیقعده',
      '12 ذیحجه',
    ],
  },
  weekDays = {
    ltr: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    rtl: ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه'],
    en: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    fa: ['شنبه', 'یکشنبه', 'دوشنبه', 'سه شنبه', 'چهارشنبه', 'پنجشنبه', 'جمعه'],
    ar: [
      'السبت',
      'الإثنين',
      'الثلاثاء',
      'الأربعاء',
      'الخميس',
      'الجمعة',
      'الأحد',
    ],
    ru: [
      'понедельник',
      'вторник',
      'среда',
      'четверг',
      'пятница',
      'суббота',
      'воскресенье',
    ],
    it: [
      'lunedì',
      'martedì',
      'mercoledì',
      'giovedì',
      'venerdì',
      'sabato',
      'domenica',
    ],
    de: [
      'Sonntag',
      'Montag',
      'Dienstag',
      'Mittwoch',
      'Donnerstag',
      'Freitag',
      'Samstag',
    ],
  };

const monthList = {
  ltr: [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ],
  rtl: [
    'فروردین',
    'اردیبهشت',
    'خرداد',
    'تیر',
    'مرداد',
    'شهریور',
    'مهر',
    'آبان',
    'آذر',
    'دی',
    'بهمن',
    'اسفند',
  ],
  hijri: [
    'محرم',
    'صفر',
    'ر-اول',
    'ر-ثانی',
    'ج-اول',
    'ج-ثانی',
    'رجب',
    'شعبان',
    'رمضان',
    'شوال',
    'ذیقعده',
    'ذیحجه',
  ],
};

export const monthListWithKey = {
  miladi: [
    {
      name: {
        fa: 'ژانویه',
        en: 'January',
        de: 'Januar',
        it: 'Gennaio',
        ru: 'Январь',
        ja: '1月',
        ar: 'يناير',
      },
      code: 1,
      dayCount: 31,
    },
    {
      name: {
        fa: 'فوریه',
        en: 'February',
        de: 'Februar',
        it: 'Febbraio',
        ru: 'Февраль',
        ja: '2月',
        ar: 'فبراير',
      },
      code: 2,
      dayCount: 28,
    },
    {
      name: {
        fa: 'مارس',
        en: 'March',
        de: 'März',
        it: 'Marzo',
        ru: 'Март',
        ja: '3月',
        ar: 'مارس',
      },
      code: 3,
      dayCount: 31,
    },
    {
      name: {
        fa: 'آوریل',
        en: 'April',
        de: 'April',
        it: 'Aprile',
        ru: 'Апрель',
        ja: '4月',
        ar: 'أبريل',
      },
      code: 4,
      day: 30,
    },
    {
      name: {
        fa: 'می',
        en: 'May',
        de: 'Mai',
        it: 'Maggio',
        ru: 'Май',
        ja: '5月',
        ar: 'مايو',
      },
      code: 5,
      dayCount: 31,
    },
    {
      name: {
        fa: 'ژوئن',
        en: 'June',
        de: 'Juni',
        it: 'Giugno',
        ru: 'Июнь',
        ja: '6月',
        ar: 'يونيو',
      },
      code: 6,
      dayCount: 30,
    },
    {
      name: {
        fa: 'جولای',
        en: 'July',
        de: 'Juli',
        it: 'Luglio',
        ru: 'Июль',
        ja: '7月',
        ar: 'يوليه',
      },
      code: 7,
      dayCount: 31,
    },
    {
      name: {
        fa: 'آگوست',
        en: 'August',
        de: 'August',
        it: 'Agosto',
        ru: 'Август',
        ja: '8月',
        ar: 'أغسطس',
      },
      code: 8,
      dayCount: 31,
    },
    {
      name: {
        fa: 'سپتامبر',
        en: 'September',
        de: 'September',
        it: 'Settembre',
        ru: 'Сентябрь',
        ja: '9月',
        ar: 'سبتمبر',
      },
      code: 9,
      dayCount: 30,
    },
    {
      name: {
        fa: 'اکتبر',
        en: 'October',
        de: 'Oktober',
        it: 'Ottobre',
        ru: 'Октябрь',
        ja: '10月',
        ar: 'أكتوبر',
      },
      code: 10,
      dayCount: 31,
    },
    {
      name: {
        fa: 'نوامبر',
        en: 'November',
        de: 'November',
        it: 'Novembre',
        ru: 'Ноябрь',
        ja: '11月',
        ar: 'نوفمبر',
      },
      code: 11,
      dayCount: 30,
    },
    {
      name: {
        fa: 'دسامبر',
        en: 'December',
        de: 'Dezember',
        it: 'Dicembre',
        ru: 'Декабрь',
        ja: '12月',
        ar: 'ديسمبر',
      },
      code: 12,
      dayCount: 31,
    },
  ],
  shamsi: [
    {
      name: {
        fa: 'فروردین',
        en: 'Farvardin',
        de: 'ّFarvardin',
        it: 'ّFarvardin',
        ru: 'ّFarvardin',
        ja: 'ّFarvardin',
        ar: 'ّFarvardin',
      },
      code: 1,
      dayCount: 31,
    },
    {
      name: {
        fa: 'اردیبهشت',
        en: 'Ordibehesht',
        de: 'Ordibehesht',
        it: 'Ordibehesht',
        ru: 'Ordibehesht',
        ja: 'Ordibehesht',
        ar: 'Ordibehesht',
      },
      code: 2,
      dayCount: 31,
    },
    {
      name: {
        fa: 'خرداد',
        en: 'Khordad',
        de: 'Khordad',
        it: 'Khordad',
        ru: 'Khordad',
        ja: 'Khordad',
        ar: 'Khordad',
      },
      code: 3,
      dayCount: 31,
    },
    {
      name: {
        fa: 'تیر',
        en: 'Tir',
        de: 'Tir',
        it: 'Tir',
        ru: 'Tir',
        ja: 'Tir',
        ar: 'Tir',
      },
      code: 4,
      dayCount: 31,
    },
    {
      name: {
        fa: 'مرداد',
        en: 'Mordad',
        de: 'Mordad',
        it: 'Mordad',
        ru: 'Mordad',
        ja: 'Mordad',
        ar: 'Mordad',
      },
      code: 5,
      dayCount: 31,
    },
    {
      name: {
        fa: 'شهریور',
        en: 'Shahrivar',
        de: 'Shahrivar',
        it: 'Shahrivar',
        ru: 'Shahrivar',
        ja: 'Shahrivar',
        ar: 'Shahrivar',
      },
      code: 6,
      dayCount: 31,
    },
    {
      name: {
        fa: 'مهر',
        en: 'Mehr',
        de: 'Mehr',
        it: 'Mehr',
        ru: 'Mehr',
        ja: 'Mehr',
        ar: 'Mehr',
      },
      code: 7,
      dayCount: 30,
    },
    {
      name: {
        fa: 'آبان',
        en: 'Aban',
        de: 'Aban',
        it: 'Aban',
        ru: 'Aban',
        ja: 'Aban',
        ar: 'Aban',
      },
      code: 8,
      dayCount: 30,
    },
    {
      name: {
        fa: 'آذر',
        en: 'Azar',
        de: 'Azar',
        it: 'Azar',
        ru: 'Azar',
        ja: 'Azar',
        ar: 'Azar',
      },
      code: 9,
      dayCount: 30,
    },
    {
      name: {
        fa: 'دی',
        en: 'Dey',
        de: 'Dey',
        it: 'Dey',
        ru: 'Dey',
        ja: 'Dey',
        ar: 'Dey',
      },
      code: 10,
      dayCount: 30,
    },
    {
      name: {
        fa: 'بهمن',
        en: 'Bahman',
        de: 'Bahman',
        it: 'Bahman',
        ru: 'Bahman',
        ja: 'Bahman',
        ar: 'Bahman',
      },
      code: 11,
      dayCount: 30,
    },
    {
      name: {
        fa: 'اسفند',
        en: 'Esfand',
        de: 'Esfand',
        it: 'Esfand',
        ru: 'Esfand',
        ja: 'Esfand',
        ar: 'Esfand',
      },
      code: 12,
      dayCount: 29,
    },
  ],
  hijri: [
    {
      name: {
        fa: 'محرم',
        en: 'محرم',
        it: 'محرم',
        ru: 'محرم',
        ja: 'محرم',
        de: 'محرم',
        ar: 'محرم',
      },
      code: 1,
      dayCount: 29,
    },
    {
      name: {
        fa: 'صفر',
        en: 'صفر',
        it: 'صفر',
        ru: 'صفر',
        ja: 'صفر',
        de: 'صفر',
        ar: 'صفر',
      },
      code: 2,
      dayCount: 30,
    },
    {
      name: {
        fa: 'ربیع الاول',
        en: 'ربیع الاول',
        it: 'ربیع الاول',
        ru: 'ربیع الاول',
        ja: 'ربیع الاول',
        de: 'ربیع الاول',
        er: 'ربیع الاول',
      },
      code: 3,
      dayCount: 29,
    },
    {
      name: {
        fa: 'ربیع الثانی',
        en: 'ربیع الثانی',
        it: 'ربیع الثانی',
        ru: 'ربیع الثانی',
        ja: 'ربیع الثانی',
        de: 'ربیع الثانی',
        ar: 'ربیع الثانی',
      },
      code: 4,
      dayCount: 30,
    },
    {
      name: {
        fa: 'جمالی الاول',
        en: 'جمالی الاول',
        it: 'جمالی الاول',
        ru: 'جمالی الاول',
        ja: 'جمالی الاول',
        de: 'جمالی الاول',
        ar: 'جمالی الاول',
      },
      code: 5,
      dayCount: 29,
    },
    {
      name: {
        fa: 'جمالی الثانی',
        en: 'جمالی الثانی',
        it: 'جمالی الثانی',
        ru: 'جمالی الثانی',
        ja: 'جمالی الثانی',
        de: 'جمالی الثانی',
        ar: 'جمالی الثانی',
      },
      code: 6,
      dayCount: 30,
    },
    {
      name: {
        fa: 'رجب',
        en: 'رجب',
        it: 'رجب',
        ru: 'رجب',
        ja: 'رجب',
        de: 'رجب',
        ar: 'رجب',
      },
      code: 7,
      dayCount: 29,
    },
    {
      name: {
        fa: 'شعبان',
        en: 'شعبان',
        it: 'شعبان',
        ru: 'شعبان',
        ja: 'شعبان',
        de: 'شعبان',
        ar: 'شعبان',
      },
      code: 8,
      dayCount: 29,
    },
    {
      name: {
        fa: 'رمضان',
        en: 'رمضان',
        it: 'رمضان',
        ru: 'رمضان',
        ja: 'رمضان',
        de: 'رمضان',
        ar: 'رمضان',
      },
      code: 9,
      dayCount: 30,
    },
    {
      name: {
        fa: 'شوال',
        en: 'شوال',
        it: 'شوال',
        ru: 'شوال',
        ja: 'شوال',
        de: 'شوال',
        ar: 'شوال',
      },
      code: 10,
      dayCount: 29,
    },
    {
      name: {
        fa: 'ذیقعده',
        en: 'ذیقعده',
        it: 'ذیقعده',
        ru: 'ذیقعده',
        ja: 'ذیقعده',
        de: 'ذیقعده',
        ar: 'ذیقعده',
      },
      code: 11,
      dayCount: 29,
    },
    {
      name: {
        fa: 'ذیحجه',
        en: 'ذیحجه',
        it: 'ذیحجه',
        ru: 'ذیحجه',
        ja: 'ذیحجه',
        de: 'ذیحجه',
        ar: 'ذیحجه',
      },
      code: 12,
      dayCount: 30,
    },
  ],
};

export const shamsiHijriDays = {
  shamsi: [
    { fa: 'شنبه', en: 'Saturday' },
    { fa: 'یکشنبه', en: 'Sunday' },
    { fa: 'دوشنبه', en: 'Monday' },
    { fa: 'سه شنبه', en: 'Tuesday' },
    { fa: 'چهارشنبه', en: 'Wednesday' },
    { fa: 'پنجشنبه', en: 'Thursday' },
    { fa: 'جمعه', en: 'Friday' },
  ],
  hijri: [
    { fa: 'السبت', en: 'Sunday' },
    { fa: 'الأحد', en: 'Saturday' },
    { fa: 'الاثنين', en: 'Monday' },
    { fa: 'الثلاثاء', en: 'Tuesday' },
    { fa: 'الأربعاء', en: 'Wednesday' },
    { fa: 'الخميس', en: 'Thursday' },
    { fa: 'الجمعة', en: 'Friday' },
  ],
};

export const fullMonths = {
  ltr: {
    en: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    fa: [
      'ژانویه',
      'فوریه',
      'مارس',
      'آوریل',
      'می',
      'ژوئن',
      'جولای',
      'آگوست',
      'سپتامبر',
      'اکتبر',
      'نوامبر',
      'دسامبر',
    ],
  },
  rtl: {
    fa: [
      'فروردین',
      'اردیبهشت',
      'خرداد',
      'تیر',
      'مرداد',
      'شهریور',
      'مهر',
      'آبان',
      'آذر',
      'دی',
      'بهمن',
      'اسفند',
    ],
    en: [
      'Farvardi',
      'Ordibehesht',
      'Khordad',
      'Tir',
      'Mordad',
      'Shahrivar',
      'Mehr',
      'Aban',
      'Azar',
      'Dey',
      'Bahman',
      'Esfand',
    ],
  },
};
export const returnClosestDateIndex = (selectedDate, currentDate) => {
  var closest = selectedDate.reduce((prev, curr) => {
    return Math.abs(
      new Date(curr.date.miladi.join('-')) - new Date(currentDate),
    ) < Math.abs(new Date(prev.date.miladi.join('-')) - new Date(currentDate))
      ? curr
      : prev;
  });
  return selectedDate.findIndex(
    (item) => item.date.miladi.join('-') === closest.date.miladi.join('-'),
  );
};
export const checkIsValidBirthDate = (
  birthDate,
  flightDate,
  direction,
  changeToMialdi,
  passengerType,
) => {
  if (
    birthDate &&
    momentjs(
      birthDate,
      direction === 'ltr'
        ? 'YYYY/M/D'
        : !changeToMialdi
        ? 'jYYYY/jMM/jDD'
        : 'YYYY/MM/DD',
    ).isValid()
  ) {
    if (direction === 'rtl' && !changeToMialdi && birthDate) {
      birthDate = momentjs(birthDate, 'jYYYY-jMM-jDD').format('YYYY-MM-DD');
    }
    //checkBirthDate
    if (!checkDateValidation(flightDate, birthDate, passengerType)) {
      return false;
    } else return true;
  } else return false;
};
export const checkIsValidExpireDate = (
  passportExpireDate,
  flightDate,
  direction,
  changeToMialdiExpire,
) => {
  if (
    (passportExpireDate !== '' &&
      momentjs(
        passportExpireDate,
        direction === 'ltr'
          ? 'YYYY/MM/DD'
          : !changeToMialdiExpire
          ? 'jYYYY/jMM/jDD'
          : 'YYYY/MM/DD',
      ).isValid()) ||
    passportExpireDate === ''
  ) {
    if (
      direction === 'rtl' &&
      passportExpireDate != '' &&
      !changeToMialdiExpire
    ) {
      passportExpireDate = momentjs(passportExpireDate, 'jYYYY-jMM-jDD').format(
        'YYYY-MM-DD',
      );
    }
    if (checkDateValidation(flightDate, passportExpireDate, 'expireDate')) {
      return true;
    } else return false;
  } else return false;
};

export const returnWeekDays = (name) => {
  return weekDays[name];
};
export const returnMonths = (type) => {
  type = normalizeType(type);
  let monthLst = [];
  for (let month = 0; month < monthList[type].length; month++) {
    monthLst.push({
      index: month + 1,
      Name: monthList[type][month],
    });
  }
  return monthLst;
};
export const returnMonthList = (direction) => {
  let monthLst = [];
  for (let month = 0; month < monthNames[direction].length; month++) {
    monthLst.push({
      index: month + 1,
      Name: monthNames[direction][month],
    });
  }
  return monthLst;
};
export const returnMonthName = (direction, index) => {
  return monthNames[direction][index - 1].split(' ')[1];
};
export const returnMonthNameswithKeys = (dateType, language, index) => {
  return monthListWithKey?.[dateType]?.[index - 1]?.name?.[language] ?? '- - -';
};
export const returnShamsiHijriDays = (dateType, day) => {
  const dayList = shamsiHijriDays[dateType]?.filter((item) => item?.en === day);
  return dayList?.[0]?.['fa'] ?? '- - -';
};

export function MonthName({ type = 'ltr', monthIndex = 0, abbr }) {
  type = normalizeType(type);
  const month = monthList[type][monthIndex - 1];
  if (abbr) return month.substring(0, 3);
  return month;
}

function normalizeType(type) {
  if (['ltr', 'rtl', 'hijri'].includes(type)) return type;
  else if (['miladi', 'gregorian'].includes(type)) return 'ltr';
  else if (['shamsi'].includes(type)) return 'rtl';
  else if (type !== type.toLowerCase())
    return normalizeType(type.toLowerCase());
  else return 'ltr';
}

//return date diff to hours and minute
export const dateDiff = (dt1, dt2) => {
  dt1 = new Date(dt1);
  dt2 = new Date(dt2);
  var diff = (dt1.getTime() - dt2.getTime()) / 1000;
  diff /= 60;
  if (diff >= 60) {
    let min = Math.round(diff) % 60;
    if (min < 10) min = `0${min}`;
    let hour = Math.abs(Math.floor(diff / 60));
    if (hour < 10) hour = `0${hour}`;
    return `${hour}:${min}`;
  } else {
    let min = Math.round(diff) % 60;
    if (min < 10) min = `0${min}`;
    return `00:${min}`;
  }
};
export const compareDate = (date1, date2) => {
  return new Date(date1) > new Date(date2);
};
export const returnDateWithWeek = (date) => {
  let dateArr = new Date(date).toDateString().split(' ');
  return `${dateArr[0]} ${dateArr[2]} ${dateArr[1]}`;
};
export const returnMiladi = () => {
  let monthName = returnMonthName(name, date[0]),
    day = returnDay('en', date),
    dayName = returnWeeekDay(date[0], 'en', true);
  {
    `${dayName} ${day} ${monthName} ${arriveYearName} at
   
  ${date[1].substring(0, 5)}`;
  }
};
export const getDateRangeByPassengerType = (passengerType, flightDate) => {
  let dateRange = {
    minDate: '1900-01-01',
    maxDate: new Date().toISOString().split('T')[0],
  };
  if (flightDate) {
    flightDate = new Date(flightDate);
    switch (passengerType) {
      //more than 12 yeras old
      case 'adult': {
        dateRange.maxDate = new Date(
          flightDate.setFullYear(flightDate.getFullYear() - 12),
        )
          .toISOString()
          .split('T')[0];
        dateRange.minDate = new Date('1900-01-01').toISOString().split('T')[0];
        return dateRange;
      }
      case 'senior': {
        dateRange.maxDate = new Date(
          flightDate.setFullYear(flightDate.getFullYear() - 65),
        )
          .toISOString()
          .split('T')[0];
        dateRange.minDate = new Date('1900-01-01').toISOString().split('T')[0];
        return dateRange;
      }
      //more than 2 and less tahn 12 years old
      case 'child': {
        let flightDate2 = new Date(flightDate);
        dateRange.minDate = new Date(
          flightDate.setFullYear(flightDate.getFullYear() - 12),
        )
          .toISOString()
          .split('T')[0];
        dateRange.maxDate = new Date(
          flightDate2.setFullYear(flightDate2.getFullYear() - 2),
        )
          .toISOString()
          .split('T')[0];
        return dateRange;
      }
      //less than 2 years old
      case 'infant':
      case 'toddler': {
        dateRange.minDate = new Date(
          flightDate.setFullYear(flightDate.getFullYear() - 2),
        )
          .toISOString()
          .split('T')[0];
        dateRange.maxDate = new Date().toISOString().split('T')[0];
        return dateRange;
      }
      case 'expireDate': {
        dateRange.minDate = new Date(
          flightDate.setMonth(flightDate.getMonth() + 6),
        )
          .toISOString()
          .split('T')[0];
        dateRange.maxDate = new Date(
          new Date().setFullYear(new Date().getFullYear() + 10),
        )
          .toISOString()
          .split('T')[0];
        return dateRange;
      }
      default:
        return dateRange;
    }
  } else return dateRange;
};
export const checkDateValidation = (flightDate, date, type) => {
  flightDate = new Date(flightDate);
  date = new Date(date);
  let diff = date.getTime() - flightDate.getTime();
  var dayDiff = diff / (24 * 60 * 60 * 1000);
  switch (type) {
    //more than 12 yeras old
    case 'adult': {
      flightDate.setFullYear(flightDate.getFullYear() - 12);
      return flightDate > date ? true : false;
    }
    //more than 2 and less tahn 12 years old
    case 'child': {
      let flightDate2 = new Date(flightDate);
      flightDate.setFullYear(flightDate.getFullYear() - 12);
      flightDate2.setFullYear(flightDate2.getFullYear() - 2);
      return flightDate <= date && flightDate2 > date ? true : false;
    }
    //less than 2 years old
    case 'infant' || 'toddler': {
      flightDate.setFullYear(flightDate.getFullYear() - 2);
      return flightDate <= date ? true : false;
    }
    //more than 60 years old
    case 'senior': {
      flightDate.setFullYear(flightDate.getFullYear() - 60);
      return flightDate > date ? true : false;
    }
    case 'expireDate': {
      return dayDiff / 30 >= 6 ? true : false;
    }
    default:
      return true;
  }
};
